import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const SiteContext = createContext(null);

export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) {
    return url;
  }
  // server-relative upload URL like /api/uploads/<id>
  return `${BACKEND_URL}${url}`;
}

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSite = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/site`);
      setSite(data);
    } catch (e) {
      console.error("Failed to load site content", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSite();
  }, [fetchSite]);

  return (
    <SiteContext.Provider value={{ site, loading, refresh: fetchSite, setSite }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be used inside SiteProvider");
  return ctx;
}
